<!--
 * @Description: 异常完成弹框
 * @Author: ChenXueLin
 * @Date: 2021-11-20 15:22:04
 * @LastEditTime: 2022-07-01 09:21:49
 * @LastEditors: ChenXueLin
-->
<template>
  <!-- 异常完成弹框 -->
  <el-dialog
    v-dialogDrag
    :title="abnormalType == 3 ? '异常提交原因' : '异常完成原因'"
    :visible="abnormalFinishDialog"
    width="500px"
    :close-on-click-modal="false"
    :element-loading-background="loadingBackground"
    :before-close="handleClose"
    v-loading="dialogLoading"
    custom-class="createDispatchDialog"
  >
    <div class="til">
      {{
        abnormalType == 3
          ? ""
          : "注：调度信息异常完成后会把所有未完成的任务退回到上一级，已完成的任务不受影响"
      }}
    </div>
    <el-form
      :model="abnormalForm"
      :rules="abnormalFormRules"
      :inline="true"
      label-width="120px"
      ref="abnormalForm"
    >
      <el-form-item
        :label="abnormalType == 3 ? '异常提交原因' : '异常完成原因'"
        prop="reason"
        v-if="abnormalType == 3"
      >
        <e6-vr-select
          v-model="abnormalForm.reason"
          :data="reasonList"
          :placeholder="abnormalType == 3 ? '异常提交原因' : '异常完成原因'"
          :title="abnormalType == 3 ? '异常提交原因' : '异常完成原因'"
          clearable
        ></e6-vr-select>
      </el-form-item>
      <el-form-item
        :label="abnormalType == 3 ? '异常提交原因' : '异常完成原因'"
        prop="reason"
        v-else
      >
        <el-input
          :placeholder="abnormalType == 3 ? '异常提交原因' : '异常完成原因'"
          v-model="abnormalForm.reason"
        ></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          placeholder="备注"
          v-model="abnormalForm.remark"
          maxlength="100"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" slot="footer">
      <el-button class="cancel" @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit"> 确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { printError } from "@/utils/util";
import { abnormalFinish, abnormalFinishItem } from "@/api";
import base from "@/mixins/base";
export default {
  name: "abnormalFinishDialog",
  components: {},
  data() {
    return {
      abnormalForm: {
        reason: "",
        remark: ""
      },
      reasonList: [
        {
          id: "实际安装数量与要求安装数据不一致",
          label: "实际安装数量与要求安装数据不一致"
        },
        {
          id: "客户车辆未到达",
          label: "客户车辆未到达"
        },
        {
          id: "其他原因",
          label: "其他原因"
        }
      ], //异常完成原因下拉框
      dialogLoading: false,
      abnormalFormRules: {
        reason: [
          {
            required: true,
            message: "请输入异常完成原因",
            trigger: ["blur", "change"]
          }
        ]
      }
    };
  },
  //abnormalType1调度任务异常完成,2调度信息异常完成,3任务项异常完成
  props: ["abnormalFinishDialog", "scheduleId", "abnormalType"],
  mixins: [base],
  computed: {},
  watch: {},
  methods: {
    //异常完成请求
    async handleAbnormalFinish() {
      try {
        this.dialogLoading = true;
        let res = await abnormalFinish({
          type: this.abnormalType,
          scheduleId: this.scheduleId,
          ...this.abnormalForm
        });
        if (res.code == "OK") {
          this.$message.success("操作成功");
          this.$emit("refreshData");
          this.abnormalForm = {
            reason: "",
            remark: ""
          };
          this.$refs.abnormalForm.resetFields();
          this.$emit("handleClose", "abnormalFinishDialog");
        }
      } catch (error) {
        printError(error);
      } finally {
        this.dialogLoading = false;
      }
    },
    //任务项异常完成
    async handleAbnormalReq() {
      try {
        this.dialogLoading = true;
        let res = await abnormalFinishItem({
          abnormalType: 3,
          bizId: this.scheduleId,
          abnormalReason: this.abnormalForm.reason,
          abnormalRemark: this.abnormalForm.remark
        });
        if (res.code == "OK") {
          this.$message.success("操作成功");
          this.$emit("refreshData");
          this.abnormalForm = {
            reason: "",
            remark: ""
          };
          this.$refs.abnormalForm.resetFields();
          this.$emit("handleClose", "abnormalFinishDialog");
        }
      } catch (error) {
        printError(error);
      } finally {
        this.dialogLoading = false;
      }
    },
    handleClose() {
      this.abnormalForm = {
        reason: "",
        remark: ""
      };
      this.$refs.abnormalForm.resetFields();
      this.$emit("handleClose", "abnormalFinishDialog");
    },
    handleSubmit() {
      this.$refs.abnormalForm.validate(valid => {
        if (valid) {
          console.log(this.abnormalType, this.abnormalType == 3);
          if (this.abnormalType == 3) {
            this.handleAbnormalReq();
          } else {
            this.handleAbnormalFinish();
          }
        }
      });
    }
  },
  created() {}
};
</script>
<style lang="scss" scoped>
/deep/.createDispatchDialog {
  .el-input {
    width: 300px;
  }
  .til {
    font-size: 12px;
    color: #606266;
    margin-top: 10px;
    margin-bottom: 15px;
    margin-left: 10px;
  }
}
</style>
